//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Images
import SE from "../../images/SE.png"
import IPhone6 from "../../images/IPhone6.png"
import IPhone7 from "../../images/IPhone7.png"
import AppleWatch from "../../images/AppleWatch.png"

const Devices = () => {
  return (
    <div className={style.devices}>
      <div className={style.device_title}>Пристрої, що підтримуються:</div>
      <div className={style.device}>
        iPhone SE
        <img src={SE} className={style.icon} alt="Таскомбанку SE" />
      </div>
      <div className={style.device}>
        iPhone 6 та новіші
        <div className={style.svg_wraper}>
          <img
            src={IPhone6}
            className={style.icon}
            alt="Таскомбанк Apple Pay для IPhone6"
          />
          <img
            src={IPhone7}
            className={[style.icon, style.small].join(" ")}
            alt="Таскомбанк Apple Pay для IPhone7"
          />
        </div>
      </div>

      <div className={style.device}>
        Apple Watch
        <img
          src={AppleWatch}
          className={style.icon}
          alt="Таскомбанк Apple Pay для AppleWatch"
        />
      </div>
    </div>
  )
}

export default Devices
